import { createStyles, Switch, Theme, withStyles } from "@material-ui/core";
import * as React from "react";

export const ExpressFleetSwitch = withStyles(
  (theme: Theme) =>
    createStyles({
      checked: {
        "&$checked": {
          "& + $track": {
            backgroundColor: "#0030ff",
            border: "none",
            opacity: 1
          },
          color: "#ffffff",
          transform: "translateX(16px)"
        },
        "&$focusVisible $thumb": {
          border: "6px solid #f44336",
          color: "#0630ff"
        },
        color: "#ffffff",
        padding: 1,
        top: "1px"
      },
      focusVisible: {},
      root: {
        height: 35,
        margin: "0 0 0 5px",
        padding: 0,
        width: 60
      },
      switchBase: {
        "&$checked": {
          "& + $track": {
            backgroundColor: "#0030ff",
            border: "none",
            opacity: 1
          },
          color: "#ffffff",
          transform: "translateX(16px)"
        },
        "&$focusVisible $thumb": {
          border: "6px solid #f44336",
          color: "#0630ff"
        },
        color: "#ffffff",
        padding: 1,
        top: "1px"
      },
      thumb: {
        height: 26,
        width: 26
      },
      track: {
        backgroundColor: "#BEBEBE",
        borderRadius: "25px",
        height: "30px",
        opacity: 2,
        transition: theme.transitions.create(["background-color", "border"]),
        width: "52px"
      }
    }),
  { name: "ExpressFleetSwitch" }
)(({ classes, ...props }: any) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      checked: classes.checked,
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track
    }}
    {...props}
  />
));

export default ExpressFleetSwitch;
